import React from "react";
import { getStyles } from "../../../assets/js/utils/functions";
import LazyImage from "../../lazy-image";
import AnimatedHeaderText from "../commons/animated-header-text";

const HowCatlogHelpsYou = () => {
  return (
    <section className="body-padding section-spacing">
      <div className="container">
        <AnimatedHeaderText
          className="mb-10 sm:mb-12.5 lg:mb-15"
          series={[
            ["Catlog", "supports", "you"],
            ["with", "the", "tools", "to"],
          ]}
        />
        <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-y-9 sm:gap-y-12.5 sm:gap-x-9 md:gap-x-9 lg:gap-x-12.5 xl:gap-15 feature-wrapper">
          {features.map((feature, index) => (
            <div className="hide-for-observer" key={index}>
              <div
                className={`w-full flex flex-col items-center anim-word-up`}
                style={getStyles({ "--delay": `${(index % 2) * 0.25}s`, "--from": "15%", "--duration": "1s" })}
              >
                <div
                  className={`w-full rounded-[18px] sm:rounded-[22px] md:rounded-3xl xl:rounded-[30px] px-6 py-8 sm:py-10 sm:px-11.25 md:py-12.5 md:px-15 lg:p-10 xl:p-12.5 xl:px-12.5 ${feature.background}`}
                >
                  <figure className="h-25 w-25 sm:h-30 sm:w-30 lg:h-36 lg:w-36 xl:h-40 xl:w-40">
                    <LazyImage src={feature.icon} alt={feature.iconAlt} showLoader={false} className="w-full" />
                  </figure>
                  <h3 className="heading-five font-bold mt-4 sm:mt-5 md:mt-7 lg:mt-7.5 text-black !leading-[1.12] max-w-[250px] sm:max-w-[1000px] lg:max-w-[340px] xl:max-w-[360px] capitalize">
                    {feature.title}
                  </h3>
                  <p className="text-black sub-text mt-3 sm:mt-3.75 md:mt-4 xl:mt-5 max-w-[370px] sm:max-w-[480px] md:max-w-[520px]">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const features = [
  {
    title: "Make more money",
    description:
      "With catlog, everyone sees all the items you sell, which would prevent you from loosing sales because buyers didn't know what you sell.",
    background: "bg-accent-yellow-pastel",
    icon: "https://res.cloudinary.com/catlog/image/upload/v1670357112/illustrations/money.webp",
    iconAlt: "Catlog money Illustration",
  },
  {
    title: "Be more efficient",
    description:
      "With Catlog you won't have to keep answering same questions from customers everytime especially if they won't end up buying.",
    background: "bg-accent-red-pastel",
    icon: "https://res.cloudinary.com/catlog/image/upload/v1670357112/illustrations/efficient.webp",
    iconAlt: "Catlog efficient Illustration",
  },
  {
    title: "Be More Visible",
    description:
      "Our advanced search engine optimization helps your store & products show up on Google, when customers search related keywords.",
    background: "bg-accent-green-pastel",
    icon: "https://res.cloudinary.com/catlog/image/upload/v1670357114/illustrations/visible.webp",
    iconAlt: "Catlog Search Illustration",
  },
  {
    title: "Stand Out",
    description:
      "The process of buying from catlog is really seamless coupled with automated customer notifications, your business will stand out.",
    background: "bg-accent-orange-pastel",
    icon: "https://res.cloudinary.com/catlog/image/upload/v1670357113/illustrations/standout.webp",
    iconAlt: "Catlog Standout Illustration",
  },
];

export default HowCatlogHelpsYou;
